import {createFeatureFlagsStore} from '#imports';

export const FeatureFlags = [
    'keyword-search-global-matching-for-localized-clients',
    'keyword-search-global-matching-for-defined-localized-countries',
] as const;
export type FeatureFlag = (typeof FeatureFlags)[number];

/**
 * features-flags store is initialized in `src/runtime/plugins/load-feature-flags`
 */
export const useFeatureFlagsStore = createFeatureFlagsStore([...FeatureFlags], 'nuxt-common-components-feature-flags-store');
